import { render, staticRenderFns } from "./DeliverySchedule.vue?vue&type=template&id=3dfb83fd&"
import script from "./DeliverySchedule.vue?vue&type=script&lang=js&"
export * from "./DeliverySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports